import { Component, HostListener, OnInit, AfterViewInit, ViewChild, Renderer2, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DayPilot, DayPilotSchedulerComponent, DayPilotNavigatorComponent } from 'daypilot-pro-angular';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { TeamEventService } from 'src/app/_services/dispo/team-event.service';
import { TeamOrderService } from 'src/app/_services/dispo/team-order.service';
import { OrderComponent } from '../../order/order.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { MapTypeStyle } from '@agm/core';
import { AgmCoreModule, AgmMap, LatLngBounds, LatLngBoundsLiteral } from '@agm/core';
import { MatTabGroup } from '@angular/material/tabs';
import { CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { PaginationInstance} from 'ngx-pagination';
import { ActionService } from 'src/app/_services/dispo/action.service';
import { TeamAbsenceService } from 'src/app/_services/dispo/team-absence.service';
import { Helper } from 'src/app/_services/dispo/helper.service';

import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer} from '@angular/cdk/a11y';
import { MatPaginator } from '@angular/material/paginator';
import { DocumentService } from 'src/app/_services/dispo/document.service';
import { MailService } from 'src/app/_services/dispo/mail.service';
import { SipgateService } from 'src/app/_services/sipgate.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

import Swal from 'sweetalert2';



@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements AfterViewInit, OnInit, OnChanges {
  
  @ViewChild(AgmMap) map: AgmMap;
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;
  @ViewChild("scheduler") scheduler!: DayPilotSchedulerComponent;
  @ViewChild("calendar") calendar!: DayPilotSchedulerComponent;
  @Output("parentFun") parentFun: EventEmitter<any> = new EventEmitter();
  @Output("parentMapFun") parentMapFun: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild( MatPaginator ) paginator: MatPaginator;

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    switch (event.key) {
      case 'F2':
        event.preventDefault();
        this.switchMiddleSlot('calendar')
        break;
      case 'F3':
        event.preventDefault();
       this.switchMiddleSlot('map')
        break;
      case 'F4':
        event.preventDefault();
        this.switchMiddleSlot('map')
        break;
      case 'F5':
        event.preventDefault();
        this.selectedSecMenuIndex = 0;
        break;
      case 'F6':
        event.preventDefault();
        this.selectedSecMenuIndex = 1;
        break;
      case 'F7':
        event.preventDefault();
        break;  

    }
  }

  

  public configPS: PerfectScrollbarConfigInterface = { wheelPropagation: true };
  @ViewChild(PerfectScrollbarComponent)
  componentRef?: PerfectScrollbarComponent;
  directiveRef?: PerfectScrollbarDirective;
  closeResult: string = '';
  orderList: any;
  rentalList: any;
  noteList: any;
  events: any[] = [];
  actions: any[] = [];
  notes: any[] = [];
  resource: any;
  middleSlot: any = 'calendar';
  currentDay = moment().format('DD.MM.yyyy');
  config: DayPilot.SchedulerConfig;
  filter: any = {
    text: ""
  };
  teamList: any;
  selectedTeamObject: any;
  dragConfig: any = { obj: [], duration: 0 * 300, id: 0 };
  action: any;
  selectedIndex = 0; //left Menu
  selectedSecMenuIndex = 1; //right Menu
  selectedCenterMenuIndex = 0; //right Menu
  highlightedDates: DayPilot.Date[] = [];
  selectedEvent: any;
  masterEventMenu: any;

  mapTypeId: string = 'roadmap';
  zoom = 18;
  tilt: number = 0;
  heading: number = 0; // Winkel der Drehung
  zoomLevel = 10; 
  latitude: any = 0;
  longitude: any = 0;
  centerLat = 51.1657; // Koordinaten für Deutschland
  centerLng = 10.4515;
  initialized = false;
  map_undisposed_orders: any;
  map_team_orders: any;
  map_customer_branch: any;
  loading: any = true;
  p: number = 1; // Startseite

  currentPage: number = 1; // Aktuelle Seite
  itemsPerPage: number = 5; // Anzahl der Elemente pro Seite
  totalPages: number = 1; // Gesamtseitenzahl (wird berechnet)
  cmode: any;

  wp_origin: any;
  wp_destination: any;

  selectedWaypoints: any;
  dispoMode: any;
  dispoDays: Number = 2;
  busyDays = ["2024-08-19", "2024-08-20", "2024-08-25"];
  prevList: [];
  teamOrderTypes: any;
  teamOrdersList: any;
  resourceSearch: any;
  orderSearch: any;
  order: any;
  calendarViews: any;
  selectedCalendarView: any;
  mapOrders: any;
  selectedMarker: any = null;

  selectedEventId: string | null = null;

  statusList: any[] = [];
  showStatusChangeModal = false;
  statusChangeModalData: { orderId: number; orderNumber: string; currentStatusId: number | null; currentStatusLabel: string } | null = null;

  payerList = [
{ id: 0, label: 'Reklamationspauschale', short: 'RP', bgcolor: '#f59d9d', color: '#fff' },
{ id: 1, label: 'Kosten ROLLER (Abstimmungsfall)', short: 'KR', bgcolor: '#9dbaf5', color: '#fff' },
{ id: 2, label: 'Fremdreklamation', short: 'FR', bgcolor: '#f5d29d', color: '#000' },
{ id: 3, label: 'SONSTIGES (siehe Notizen)', short: 'SON', bgcolor: '#ffffff', color: '#000' }
  ];

  dataSource: any;
  displayedColumns: string[] = ['id','label','identity', 'type', 'company','default_start', 'default_end','cal_calendar','deleted_at','killable','action'];
  selectedResource: any;
  selectedDate: any;
  
  // Funktion, um die Hintergrundfarbe zu ermitteln
  // Regel:
  // - Rekla (order_type_id === 0): nach Payer einfärben, sonst order_type.color
  // - Alle anderen (z. B. order_type_id === 1): IMMER die im order_type hinterlegte Farbe
  getBackgroundColor(order) {
    if (!order) { return '#fff'; }
    if (order?.order_type_id === 0) {
      const payer = this.payerList.find(p => p.id === order?.rekla_payer_id);
      return payer ? payer.bgcolor : (order?.order_type?.color || '#fff');
    }
    return order?.order_type?.color || '#fff';
  }
  
 // Funktion, um die Schriftfarbe zu ermitteln (bei Rekla ggf. nach Payer)
 getTextColor(order) {
    if (!order) { return '#000'; }
    if (order?.order_type_id === 0) {
      const payer = this.payerList.find(p => p.id === order?.rekla_payer_id);
      return payer ? payer.color : '#000';
    }
    return '#000';
  }

  getPayerName(order) {
    const payer = this.payerList.find(p => p.id === order?.rekla_payer_id);
    return payer ? payer.label : 'kein Zahler def.'; // Standardfarbe ist Schwarz
  }

  getPayerShort(order) {
    const payer = this.payerList.find(p => p.id === order?.rekla_payer_id);
    return payer ? payer.short : 'no Type'; // Standardfarbe ist Schwarz
  }

  loadStatusList(): void {
    this.orderService.getFilter().subscribe(
      (data: any) => {
        this.statusList = data.statuses || [];
      },
      () => {
        this.statusList = [];
      }
    );
  }

  openStatusChangeModalFromContextMenu(eventData: any): void {
    // Event-Daten kommen von DayPilot: TeamOrder mit order_id (Order.id) und id (TeamOrder.id)
    // WICHTIG: order_id verwenden, NICHT id (das wäre team_order.id → 404)
    const order = eventData?.order || eventData?.data?.order;
    const orderId = order?.id ?? eventData?.order_id ?? eventData?.orderId ?? eventData?.data?.order_id ?? eventData?.data?.orderId;
    if (!orderId) {
      this.toastr.warning('Keine Auftrags-ID zum Termin gefunden', 'Hinweis');
      return;
    }
    const ord = order && order.id ? order : {
      id: orderId,
      status_id: eventData?.order?.status_id ?? eventData?.status_id,
      status: eventData?.order?.status ?? eventData?.status,
      order_number: eventData?.order?.order_number ?? eventData?.order_number,
      root_order: eventData?.order?.root_order ?? eventData?.root_order
    };
    this.openStatusChangeModalForOrder(ord);
  }

  openStatusChangeModalForOrder(ord?: any): void {
    const order = ord || this.item;
    if (!order?.id) {
      this.toastr.warning('Kein Auftrag ausgewählt', 'Hinweis');
      return;
    }
    const orderId = Math.floor(Number(order.id));
    const orderNumber = order?.order_number || order?.root_order?.order_number || '';
    const currentStatusId = order?.status_id ?? order?.status?.id ?? null;
    const currentStatusLabel = order?.status?.label || order?.status?.name || '–';
    this.statusChangeModalData = {
      orderId,
      orderNumber,
      currentStatusId,
      currentStatusLabel
    };
    this.showStatusChangeModal = true;
  }

  closeStatusChangeModal(): void {
    this.showStatusChangeModal = false;
    this.statusChangeModalData = null;
  }

  changeOrderStatusFromModal(newStatusId: number): void {
    if (!this.statusChangeModalData) return;
    const { orderId } = this.statusChangeModalData;
    const numericOrderId = Math.floor(Number(orderId));
    if (isNaN(numericOrderId) || numericOrderId < 1) {
      this.toastr.error('Ungültige Auftrags-ID', 'Fehler');
      return;
    }
    const newStatus = this.statusList.find(s => s.id === newStatusId);
    const newStatusLabel = newStatus?.label || String(newStatusId);
    this.orderService.updateStatus(numericOrderId, newStatusId).subscribe({
      next: () => {
        this.toastr.success(`Status erfolgreich zu "${newStatusLabel}" geändert`, 'Status aktualisiert');
        if (this.item) {
          this.item.status_id = newStatusId;
          this.item.status = newStatus || { id: newStatusId, label: newStatusLabel, color: newStatus?.color };
        }
        if (this.order) {
          this.order.status_id = newStatusId;
          this.order.status = newStatus || { id: newStatusId, label: newStatusLabel, color: newStatus?.color };
        }
        this.fetchResources(null, null);
        this.closeStatusChangeModal();
      },
      error: (err) => {
        const msg = err?.error?.error || err?.error?.message || err?.message || 'Unbekannter Fehler';
        const details = err?.error?.details ? ' ' + JSON.stringify(err.error.details) : '';
        console.error('Fehler beim Status-Update:', err);
        this.toastr.error(msg + details, 'Fehler beim Ändern des Status');
        this.closeStatusChangeModal();
      }
    });
  }

  private getReklaSelectedType(order: any): 'system' | 'ap' | 'ist' | '' {
    if (!order || order.order_type_id !== 0) {
      return '';
    }
    const type = (order.rekla_selected_type || '').toLowerCase();
    if (type === 'system' || type === 'ap' || type === 'ist') {
      return type as 'system' | 'ap' | 'ist';
    }
    return '';
  }

  getReklaSelectedTypeLabel(order: any): string {
    const type = this.getReklaSelectedType(order);
    switch (type) {
      case 'ist':
        return 'IST';
      case 'ap':
        return 'AP';
      case 'system':
        return 'SYS';
      default:
        return '';
    }
  }

  getReklaSelectedMinutes(order: any): number | null {
    const type = this.getReklaSelectedType(order);
    switch (type) {
      case 'ist':
        return order?.rekla_real ?? null;
      case 'ap':
        return order?.rekla_ap ?? null;
      case 'system':
        return order?.duration ?? null;
      default:
        return null;
    }
  }

  getReklaSelectedHours(order: any): string {
    const minutes = this.getReklaSelectedMinutes(order);
    if (minutes === null) {
      return '';
    }
    return this.helper.convertMinutesToHours(minutes);
  }

  isRekla(order: any): boolean {
    return order?.order_type_id === 0;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }


  confirmCall(number: string, first_name: string, last_name: string) {
    Swal.fire({
      title: 'Anrufen',
      text: 'Wollen Sie ' + first_name + ' ' + last_name + ' wirklich anrufen?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nein'
    }).then((result) => {
      if (result.isConfirmed) {
        this.call(number);
      }
    });
  }


  



  mapStyles: MapTypeStyle[] = [
    /*
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        { color: '#e9e9e9' },
        { lightness: 17 }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [
        { color: '#f5f5f5' },
        { lightness: 20 }
      ]
    },
    */
    // add more MapTypeStyle objects as needed
  ];

  @Input() module_id: any;
  @Input() module_item_id: any;
  @Input() item: any;
  @Input() calmod: any;
  @Input() mode: any;

  @Input('ngModel') description: any;
  @Input('ngModel') schedulerView: any = 0;
  @Input('ngModel') viewType: any = 0;
  @Input('ngModel') timeRange: any = 1;
  @Input('ngModel') selectedTeam: any = 0;

  @Input('draggableToScheduler') draggableToScheduler: any = 0;

  public configPagination: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  constructor(
    private renderer: Renderer2,
    private modalService: NgbModal,
    private orderSerivce: OrderService,
    private teamBaseService: TeamBaseService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private teamEventService: TeamEventService,
    private teamOrderService: TeamOrderService,
    private orderService: OrderService,
    private actionService: ActionService,
    private teamAbsenceService: TeamAbsenceService,
    private helper: Helper,
    private _liveAnnouncer: LiveAnnouncer,
    private documentService: DocumentService,
    private mailService: MailService,
    private sipgateService: SipgateService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    //this.initializeDummyData();
    
    this.changeSchedulerView();
    this.loadAvailableTeams(); // Lade Teams für vorgeschlagene Termine
    this.loadStatusList();
    
    // Überschreibe Material Design Tab-Farben nach dem Laden
    setTimeout(() => {
      this.forceTabColors();
    }, 1000);
  }

  // Überschreibt alle Material Design Tab-Farben mit Headerfarbe
  forceTabColors() {
    const tabLabels = document.querySelectorAll('.mat-tab-label');
    tabLabels.forEach((tab: Element) => {
      const tabElement = tab as HTMLElement;
      tabElement.style.setProperty('background', '#2c3e50', 'important');
      tabElement.style.setProperty('background-color', '#2c3e50', 'important');
      tabElement.style.setProperty('color', '#ffffff', 'important');
    });
  }

  ngAfterViewInit(): void {
    //this.dragConfig = { obj: this.item, duration: this.item.duration * 300, id: this.item.id }
    const self = this;
    //this.fetchResources>
    
    // Header-Zellen stylen
    this.styleHeaderCells();
    //this.fetchEvents();
    this.initialized = true;
    //var from = this.scheduler.control.visibleStart();
    //var to = this.scheduler.control.visibleEnd();
    this.latitude = this.item?.lat;
    this.longitude = this.item?.lng;

    setTimeout(() => {
      if (this.scheduler?.control) {
          let from = this.scheduler.control.visibleStart();
          let to = this.scheduler.control.visibleEnd();
          this.fetchResources(null, null);
      }
    }, 200); //

    this.tabGroup.selectedIndexChange.subscribe((index: number) => {
      if (index === 0) { // Index des Tabs mit der Karte
        setTimeout(() => {
          if (this.map) {
            this.map.triggerResize(true);
          }
        }, 100);
      }
    });
    //this.dayView();
    //this.config.events = this.events;
   
  }

    ngOnChanges(changes: SimpleChanges) {
    if(this.initialized) {
      if ((changes.item && changes.item.currentValue != null) || this.calmod=='scheduler') {
          this.fetchResources(null,null);
      }
    }  
  }

  translateWeekday(weekday: string): string {
    const weekdays: { [key: string]: string } = {
      'Mon': 'Mo',
      'Tue': 'Di',
      'Wed': 'Mi',
      'Thu': 'Do',
      'Fri': 'Fr',
      'Sat': 'Sa',
      'Sun': 'So'
    };
    return weekdays[weekday] || weekday;
  }

  mapGetOrderDetails(args) {
    this.selectedMarker = args;
    if (this.calmod == 'calendar') {
      this.selectedSecMenuIndex = 0;
      this.selectedEvent = args;
      this.fetchOrderDetails(args.id);
    } else if (this.calmod == 'scheduler') {
      this.selectedSecMenuIndex = 0;
      this.fetchOrderDetails(args.id);
    }
  }

  markerclicked($event) {

  }

  selectCalendarView(id) {
    this.selectedCalendarView = id;
    this.fetchResources(null,null);
  }

  openDoc(document) {
    this.documentService.show(document).subscribe((blob: Blob) => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      // Öffne einen neuen Tab und setze die URL
      const newTab = window.open('', '_blank');
      if (newTab) {
        newTab.location.href = fileURL;
      } else {
        console.error('Pop-up wurde blockiert');
      }
    });
  }
  
  // Dokumenten-Methoden (wie in order-overview)
  openDocument(doc: any) {
    this.documentService.showDocument(doc).subscribe(
      (data: Blob) => {
        const url = window.URL.createObjectURL(data);
        window.open(url, '_blank');
      },
      (err) => {
        console.error('Fehler beim Anzeigen des Dokuments:', err);
      }
    );
  }

  getAllDocuments(): any[] {
    return this.order?.docs || [];
  }

  getAllDocumentsSorted(): any[] {
    const docs = this.getAllDocuments();
    if (!docs || docs.length === 0) return [];
    
    // Sortiere: PDFs zuerst, dann Videos, dann Bilder
    return docs.sort((a: any, b: any) => {
      const aName = a.name || a.origin_name || '';
      const bName = b.name || b.origin_name || '';
      const aExt = aName.split('.').pop()?.toLowerCase();
      const bExt = bName.split('.').pop()?.toLowerCase();
      
      // PDFs zuerst
      if (aExt === 'pdf' && bExt !== 'pdf') return -1;
      if (aExt !== 'pdf' && bExt === 'pdf') return 1;
      
      // Videos als zweites
      const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'];
      const aIsVideo = videoExtensions.includes(aExt);
      const bIsVideo = videoExtensions.includes(bExt);
      if (aIsVideo && !bIsVideo) return -1;
      if (!aIsVideo && bIsVideo) return 1;
      
      // Bilder zuletzt
      return 0;
    });
  }

  getImageVideoDocuments(): any[] {
    if (!this.order?.docs) return [];
    return this.order.docs.filter((doc: any) => this.isImageOrVideo(doc));
  }

  isPdf(doc: any): boolean {
    const fileName = doc.name || doc.origin_name || '';
    const extension = fileName.split('.').pop()?.toLowerCase();
    return extension === 'pdf';
  }

  isImageOrVideo(doc: any): boolean {
    const fileName = doc.name || doc.origin_name || '';
    const extension = fileName.split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'];
    return imageExtensions.includes(extension) || videoExtensions.includes(extension);
  }

  isImage(doc: any): boolean {
    const fileName = doc.name || doc.origin_name || '';
    const extension = fileName.split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    return imageExtensions.includes(extension);
  }

  isVideo(doc: any): boolean {
    const fileName = doc.name || doc.origin_name || '';
    const extension = fileName.split('.').pop()?.toLowerCase();
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'];
    return videoExtensions.includes(extension);
  }

  getDocumentThumbnailUrl(doc: any): string {
    return environment.prismaApiUrl + '/api/common/documents/showDocument/' + doc.id;
  }

  getThumbnailSrc(doc: any): string {
    // Verwende immer die direkte URL für Thumbnails
    return this.getDocumentThumbnailUrl(doc);
  }

  onImageLoad(event: any) {
    // Setze Opacity auf 1, wenn das Bild geladen ist
    if (event && event.target) {
      event.target.style.opacity = '1';
    }
  }

  onImageLoadStart(event: any) {
    // Prüfe, ob das Bild bereits geladen ist (für gecachte Bilder)
    if (event && event.target) {
      setTimeout(() => {
        if (event.target.complete && event.target.naturalHeight !== 0) {
          event.target.style.opacity = '1';
        }
      }, 100);
    }
  }

  openMediaInLightbox(doc: any, index: number = 0) {
    // Einfache Implementierung: Öffne direkt das Dokument
    this.openDocument(doc);
  }

  onOrderImageError(event: any, doc: any) {
    console.error('Error loading thumbnail for document:', doc.id, doc.name);
    // Fallback auf Platzhalter oder grauen Hintergrund beibehalten
    if (event && event.target) {
      event.target.style.display = 'none';
    }
  }

  convertDurationToHoursAndMinutes(duration: number): string {
    const hours = Math.floor(duration / 60);
    const minutes = duration % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}min`;
    } else {
      return `${minutes}min`;
    }
  }


  initializeDummyData() {
    this.selectedWaypoints = [
      { lat: 54.3233, lng: 10.1228 }, // Kiel
      { lat: 54.3795, lng: 10.1553 }, // Stop 1
      { lat: 54.3239, lng: 10.1308 }, // Stop 2
      { lat: 54.3213, lng: 10.1347 }  // Stop 3
    ];
    console.log('Dummy data initialized:', this.selectedWaypoints);
  }



  getOrigin() {
    if (this.selectedWaypoints?.length) {
      const firstWaypoint = this.selectedWaypoints[0];
      console.log('Origin:', firstWaypoint.lat, firstWaypoint.lng);
      return { lat: firstWaypoint.lat, lng: firstWaypoint.lng };
    }
    return null;
  }

  getDestination() {
    if (this.selectedWaypoints?.length) {
      const lastWaypoint = this.selectedWaypoints[this.selectedWaypoints.length - 1];
      console.log('Destination:', lastWaypoint.lat, lastWaypoint.lng);
      return { lat: lastWaypoint.lat, lng: lastWaypoint.lng };
    }
    return null;
  }

  getWaypoints() {
    if (this.selectedWaypoints?.length > 2) {
      const waypoints = this.selectedWaypoints.slice(1, -1).map(waypoint => ({
        location: { lat: waypoint.lat, lng: waypoint.lng },
        stopover: true
      }));
      console.log('Waypoints:', waypoints);
      return waypoints;
    }
    return [];
  }

  // Method to check if the item is disposed
  isItemNotDisposed(): boolean {
    return !this.loading && this.item && (this.item.disposed == null || this.item.disposed === 'undefined');
  }

  // Method to handle the drag start event
  onDragStart(event: DragEvent): void {
    // Find the dispo-card element
    const dragElement = (event.target as HTMLElement).closest('.dispo-card') as HTMLElement;
    if (!dragElement) return;
    
    // Create a custom drag image
    const dragImage = dragElement.cloneNode(true) as HTMLElement;
    
    // Style the drag image to be visible
    dragImage.style.position = 'fixed';
    dragImage.style.top = '50%';
    dragImage.style.left = '50%';
    dragImage.style.width = '200px';
    dragImage.style.opacity = '0.95';
    dragImage.style.transform = 'translate(-50%, -50%) rotate(5deg)';
    dragImage.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5)';
    dragImage.style.zIndex = '99999';
    dragImage.style.pointerEvents = 'none';
    dragImage.style.border = '3px solid #2c3e50';
    dragImage.style.borderRadius = '8px';
    dragImage.style.backgroundColor = '#ffffff';
    dragImage.style.transition = 'none';
    dragImage.id = 'drag-image-temp';
    
    // Add to document
    document.body.appendChild(dragImage);
    
    // Set as drag image
    event.dataTransfer?.setDragImage(dragImage, 100, 50);
    
    // Keep the drag image visible during drag
    const dragEndHandler = () => {
      const tempElement = document.getElementById('drag-image-temp');
      if (tempElement) {
        document.body.removeChild(tempElement);
      }
      document.removeEventListener('dragend', dragEndHandler);
    };
    
    document.addEventListener('dragend', dragEndHandler);
  }

 
  // Method to get the item's background color
  getItemBackgroundColor(): string {
    return this.item?.order_type?.color;
  }

  // Method to get the draggable data
  getDraggableData(): any {
    //DYNAMIC DURATION
    //return { obj: this.item, duration: this.item?.duration * 300, id: this.item?.id };
    //FIX DURATION
    return { obj: this.item, duration: 360, id: this.item?.id };

  }

  genKitchenDeliveryList() {
    alert('Im nächsten Update enthalten');
    //let start = wStart ? wStart : this.scheduler.control.visibleStart();
    //let end = wEnd ? wEnd : this.scheduler.control.visibleEnd();
  }

  genKitchenAssemblyList() {
    alert('Im nächsten Update enthalten');
  }



  changeText(val: string) {
    this.filter.text = val;
    this.applyFilter();
  }



  

  

  onTabChange(event: any): void {
    if (event.index === 0) { // Index des Tabs mit der Karte
      setTimeout(() => {
        this.map.triggerResize(true);
      }, 100);
    }
    
    // Header-Zellen stylen nach Tab-Wechsel
    this.styleHeaderCells();
  }

  call(number) {
    //event ? event.stopPropagation() : '';
    this.toastr.success('Telefonnummer:'+ number + 'wird angerufen.');
    this.actionService.addComment(this.item.id,'Anruf','Anruf TelNr.: ' + number).subscribe(
      data => {
        this.actions = data;
        window.location.href = "tel:" + number;
      },
      err => {

      }
  
    );
    
    
  }

  // E-Mail Navigation aus Kalender
  openMail(orderId: number, email: string | null) {
    if (!orderId || !email) { return; }
    this.router.navigate(['./order', orderId, 'order-scheduler', orderId, 'mail'], { relativeTo: this.route.root });
  }

  // Kompatible Methode für Klick in der Detailtabelle
  sendEmail(orderId: number, email: string | null) {
    this.openMail(orderId, email);
  }

  private async onPostDropActions(args: any) {
    const order = args?.e?.data?.order || this.order;
    const customerEmail = order?.root_order?.person?.email || order?.person?.email || null;
    const customerPhone = order?.root_order?.person?.phone || order?.person?.phone || null;

    const result = await Swal.fire({
      title: 'Nach Disposition ausführen?',
      html: `
        <div class="text-left">
          <label class="d-block"><input type="checkbox" id="opt_mail" checked> Termin per E-Mail versenden</label>
          <label class="d-block"><input type="checkbox" id="opt_call"> Kunden anrufen</label>
          <label class="d-block"><input type="checkbox" id="opt_spool"> Termin auf Anruferliste</label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Abbrechen'
    });

    if (!result.isConfirmed) return;

    const optMail = (document.getElementById('opt_mail') as HTMLInputElement)?.checked;
    const optCall = (document.getElementById('opt_call') as HTMLInputElement)?.checked;
    const optSpool = (document.getElementById('opt_spool') as HTMLInputElement)?.checked;

    try {
      if (optMail && order?.id && customerEmail) {
        this.openMail(order.id, customerEmail);
      }
      if (optCall && customerPhone) {
        this.confirmCall(String(customerPhone), order?.root_order?.person?.first_name || '', order?.root_order?.person?.last_name || '');
      }
      if (optSpool) {
        this.toastr.info('Termin wurde zur Anruferliste (Spooler) vorgemerkt. Umsetzung folgt.');
      }
    } catch (e) {
      this.toastr.error('Aktionen konnten nicht ausgeführt werden');
    }
  }

  eventRender(args) {
   
      args.cell.backColor = '#f0f';
    
  }

  

navigatorConfig: DayPilot.NavigatorConfig = {
  selectMode: "Week",
  cellWidth: 38,
  showMonths: 1,
  showWeekNumbers: true, // Wochenzahlen anzeigen (optional)
  cellHeight: 24,
  freeHandSelectionEnabled: false,
  weekStarts: 1,  // Setzt den Wochenstart auf Montag (1 = Montag)
  onBeforeCellRender: args => {
    const busyDays = [
      { start: "2024-08-19", color: "#ff0000" },
      { start: "2024-08-20", color: "#00ff00" },
      { start: "2024-08-25", color: "#0000ff" }
    ];

    // Convert the Date object to a string in the same format as the busyDays array
    const cellDate = new DayPilot.Date(args.cell.day).toString("yyyy-MM-dd");

    // Find the busy day entry matching the cellDate
    const busyDay = busyDays.find(day => day.start === cellDate);

    if (busyDay) {
      args.cell.cssClass += " busy-day";  // Apply a custom CSS class
      args.cell.html = `<div style="background-color: ${busyDay.color}; color: white;">${args.cell.day.getDay()}</div>`;  // Customize HTML with the specific color
    }
  }
};

  
  


    //onTimeRangeSelected: args => {
    //  this.config.startDate = DayPilot.Date.today(); // Beispiel: Aktualisieren Sie den Startdatum des Schedulers
    //this.config.update();
    //}
  


  

    onNavigatorDateChange(args: DayPilot.Date) {
      // Das übergebene Datum in args ist der Tag, von dem wir den Wochenstart berechnen
      let selectedDate = new DayPilot.Date(args);
    
      // Berechne den Start der Woche (Montag)
      let startOfWeek = selectedDate.firstDayOfWeek(DayPilot.Locale.find("de-de").weekStarts); // Monday as start of the week
    
      // Berechne das Ende der Woche (Sonntag)
      let endOfWeek = startOfWeek.addDays(6); // Fügt 6 Tage hinzu, um den Sonntag zu erhalten
    
      // Setze den Start und die Anzahl der Tage in der Scheduler-Konfiguration
      this.config.startDate = startOfWeek;
      this.config.days = 7;  // Zeigt 7 Tage an (Montag bis Sonntag)

      let start =  startOfWeek.toString();
      let end = endOfWeek.toString();
    
      // Optional: Aktualisiere den Scheduler
      this.fetchResources(start, end);
    
      // Debug-Ausgabe (optional)
      console.log("Start der Woche:", startOfWeek.toString());
      console.log("Ende der Woche:", endOfWeek.toString());
    }

  applyFilter() {
    this.scheduler.control.events.filter(this.filter);
  }

  applyTeamFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onSelect(object) {
    
  }



  mapActionCenterOrder() {
    if (this.item && this.map) {
      this.map.latitude = this.item.lat;
      this.map.longitude = this.item.lng;
      console.log('Map centered on item:', this.item);
    }
  }

  mapActionSwitchViewMode() {
    if (this.mapTypeId === 'roadmap') {
      this.mapTypeId = 'satellite';
    } else {
      this.mapTypeId = 'roadmap';
    }
    console.log('Map view mode switched to:', this.mapTypeId);
  }

  mapActionSwitch3D2D() {
    this.tilt = this.tilt === 0 ? 45 : 0; // Wechselt zwischen 2D (0) und 3D (45)
    console.log('Map tilt switched to:', this.tilt);
  }

  mapActionRotate() {
    this.heading = (this.heading + 45) % 360;
    //this.map.setHeading(this.heading);
    console.log('Map heading rotated to:', this.heading);
  }

  changeTilt(event) {}

  changeViewType() {}

  changeSchedulerView() {
    if (this.schedulerView == 0) { this.weekView(); }
    if (this.schedulerView == 1) { this.weekView(); } 
  };

  reserveTeamOrder(args) {
    this.teamOrderService.setReserved(args.id).subscribe(
      data => {
        this.fetchResources(null,null);
        this.toastr.success('Termin wurde reserviert und der Kommunikationsliste hinzugefügt');
      },
      err => {
        this.toastr.error('Event konnte nicht blockiert werden');
      }
    );
  
  }

  

   copyPasteTeamOrder(args) {
    try {
      this.teamOrderService.copyTeamOrder(args);
      //this.fetchResources(null, null);
      this.toastr.success('Termin wurde kopiert');
    } catch (error) {
      this.toastr.error('Fehler beim Kopieren des Termins');
    }
  }

  pasteTeamOrder() {
    
    Swal.fire({
      title: `Soll dieser Auftrag auf ${new Date(this.selectedDate).toLocaleDateString('de-DE')} verschoben werden?`,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Ja',
      denyButtonText: 'Nein',
      customClass: {
        container: 'dispose_container'
      },
      input: 'checkbox',
      inputPlaceholder: 'Verweis auf Ursprungstermin anzeigen'
    }).then((result) => {
      if (result.isConfirmed) {
        const showReference = result.value; // Wert der Checkbox
        this.teamOrderService.pasteTeamOrder(this.selectedDate, this.selectedDate, this.selectedResource, showReference).subscribe(
          data => {
            this.fetchResources(null, null);
            this.toastr.success('Termin wurde eingefügt');
          },
          err => {
            this.toastr.error('Fehler beim Einfügen des Termins');
          }
        );
      } else if (result.isDenied) {
        this.toastr.info('Verschieben des Auftrags wurde abgebrochen');
      }
    });
    
  }

  getClipboardContent() {
    return this.teamOrderService.getClipboardObject();
  }



  setIsNoShow(args) {
    this.teamOrderService.setIsNoShow(args.id).subscribe(
      data => {
        this.fetchResources(null,null);
        this.toastr.success('Termin wurde als Nicht erschienen markiert');
      },
      err => {
        this.toastr.error('Termin konnte nicht als Nicht erschienen markiert werden');
      }
    );
  }

  confirmAppointment(object) {
    console.log(object);
    this.teamOrderService.confirm(object).subscribe(
      data => {
        this.fetchResources(null,null);
        this.toastr.success('Termin wurde bestätigt');
      },
      err => {
        this.toastr.error('Termin konnte nicht bestätigt werden');
      }
    );
  }

  deleteTeamOrder(object) {
    Swal.fire({
      title: 'Soll dieser Termin wirklich gelöscht werden?',
      showDenyButton: true,
      showCancelButton: true,
      customClass: {
        container: 'dispose_container'
      },
      confirmButtonText: 'Termin löschen',
      denyButtonText: `Termin nicht löschen`,
    }).then((result) => {
      
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.teamOrderService.delete(object).subscribe(
          data => {
            Swal.fire('Termin wurden gelöscht!', '', 'success');   
            this.fetchResources(null,null);
            //this.scheduler.update(); 

          },
          err => {
            this.toastr.error('Es sind Probleme aufgetaucht');
          }
        );
        
      } else if (result.isDenied) {
        Swal.fire('Termin wurde nicht gelöscht', '', 'info')
      }
    })
  }

  editOrder(object) {
    console.log(object);
    let id = object.source.data.order_id;
    alert('Auftrag wird gewechselt' + id);
    this.router.navigate(['./order/' + id + '/order-scheduler']);
    this.orderService.show(id).subscribe(
      data => {
        this.item = data;  
        this.fetchResources(null,null);
      
      },
      err => {
        this.toastr.error('Es sind Probleme aufgetaucht');
      }
    );
  }

  editTeamOrder(object) {
    
    let id = object.source.data.id;
  
    this.router.navigate(['./teamorder-details/' + id + '/teamorder-base' ], { relativeTo: this.route });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedEvent.team_orders, event.previousIndex, event.currentIndex);
  }



  onViewChange(args: any) {
    //this.fetchResources();
    //this.fetchEvents();
  }

  next() {
    let newStartDay = new DayPilot.Date(this.config.startDate).addDays(1);
    this.config.startDate = newStartDay;
   
  }

  prevPage() {
    if (this.p > 1) {
      this.p -= 1;
    }
  }
  
  // Methode, um zur nächsten Seite zu navigieren
  nextPage() {
    this.p += 1;
  }

  filterResources() {
    const searchInput = this.resourceSearch.toLowerCase();
    const filteredResources = this.resource.filter(resource => 
        resource.name.toLowerCase().includes(searchInput)
    );

    // Scheduler aktualisieren
    this.config.resources = filteredResources;
    this.scheduler.control.update();
}

  searchOrder () {
    
  }

  fetchOrderDetails(id) {
    this.orderService.show(id).subscribe(
      data => {
        this.order = data;  
        //this.fetchResources(null,null);
      
      },
      err => {
        this.toastr.error('Es sind Probleme aufgetaucht');
      }
    );
  }

  dispose_from_prev(item, prev) {
   
    let data = {
      start: prev.prev_start,
      end: prev.prev_end_time,
      resource: prev.dispo_resource,
      team_order_type_id: this.dispoMode.id,
      service_type: 'LM',
      id: item.id,
      data: item
    }

    Swal.fire({
      title: 'Soll dieser Auftrag auf den ' + new Date(data.start).toLocaleDateString('de-DE') + ' terminiert werden?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Termin buchen',
      denyButtonText: `Termin nicht buchen`,
    }).then((result) => {
      if (result.isConfirmed) {
       
        this.teamOrderService.store(data).subscribe(
          data => {
            //this.events = data;
            //this.config.events = data;
            this.toastr.success('Auftrag wurde erfolgreich disponiert');
            this.fetchResources(null,null);
          },
          err => {
            this.toastr.warning(err.error.message, 'Fehler');
          }
        );   
      } else if (result.isDenied) {
        Swal.fire('Termin wurde nicht gebucht', '', 'info')
      }
    
   
     
     
    })

    
    
   
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);
  
    // Formatierung des Datums
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-basiert
    const year = date.getFullYear();
  
    return `${day}.${month}.${year}`;
  }

  convertToHoursAndMinutes(value): string {
    const minutes = value * 5;
    const hours = Math.floor(minutes / 60); // Berechnung der Stunden
    const remainingMinutes = minutes % 60; // Berechnung der verbleibenden Minuten
    return `${hours}h, ${remainingMinutes}min`;
  }

  prev() {
    let newStartDay = new DayPilot.Date(this.config.startDate).addDays(-1);
    this.config.startDate = newStartDay;
   
  }

  highlightEvent(prev: any) {
    //console.log(prev);
    const resourceId = 'G' + prev.team_base.id; // Annahme: Die Ressource hat diese ID-Logik
    const startDate = prev.prev_start; // Startdatum des Events
  
    // Korrigierte Version mit Date-Parsing, unter Annahme, dass das Datum im Format 'YYYY-MM-DD' vorliegt
    const parsedStartDate = DayPilot.Date.parse(startDate, "yyyy-MM-dd");
    console.log(startDate);
  
    // Suche das Event im Scheduler, das mit der Ressource und dem Startdatum übereinstimmt
    
    const events = this.scheduler.events.filter(event => {
      const eventStart = event.start;
    
      return event.resource === resourceId 
        && (typeof eventStart === 'string' 
            ? eventStart.includes(startDate)  // Falls event.start ein String ist
            : eventStart instanceof Date && eventStart.toISOString().includes(startDate)  // Falls event.start ein Date ist
        );
    });
    
    

    console.log(events);
  
    // Ändere das CSS des Events, um es hervorzuheben
    events.forEach(event => {
      event.backColor = "#ffcc00";  // Ändert die Hintergrundfarbe des Events
      this.scheduler.control.events.update(event); // Aktualisiere das Event
    });
  }
  
  clearHighlight(prev: any) {
    
    const resourceId = 'G' + prev.team_base.id; // Gleiche Logik wie bei highlightEvent
    const startDate = prev.prev_start; // Startdatum des Events
  
    // Suche das Event im Scheduler, das mit der Ressource und dem Startdatum übereinstimmt
    const events = this.scheduler.events.filter(event => {
      const eventStart = event.start;
  
      return event.resource === resourceId 
        && (typeof eventStart === 'string' 
            ? eventStart.includes(startDate)  // Falls event.start ein String ist
            : eventStart instanceof Date && eventStart.toISOString().includes(startDate)  // Falls event.start ein Date ist
        );
    });
  
    // Entferne die CSS-Klasse "highlight" von den gefundenen Events
    events.forEach(event => {
      event.backColor = "#eee";  // Ändert die Hintergrundfarbe des Events
      this.scheduler.control.events.update(event); // Aktualisiere das Event im Scheduler
    });
  }
  

  fetchResources(wStart: string, wEnd: string): Promise<void> {
    //Ressourcen laden
    this.loading = true;
    
    return new Promise((resolve, reject) => {
      let start = wStart ? wStart : this.scheduler.control.visibleStart();
      let end = wEnd ? wEnd : this.scheduler.control.visibleEnd();
  
      //let mode = 1;
      let range: any = {
        start: start,
        end: end,
        mode: this.calmod,
        order: this.item,
        selectedCalendarView: this.selectedCalendarView
      };
  
      this.teamBaseService.calendarAllByDateRange(range, this.calmod).subscribe(
        data => {
          // Daten aktualisieren
          this.dataSource = new MatTableDataSource(data.teams);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.resource = data.resources;
          this.teamOrderTypes = data.teamOrderTypes;
          this.dispoMode = data.teamOrderTypes ? data.teamOrderTypes[0] : null;
          this.map_undisposed_orders = data.map_undisposed_orders;
          this.map_team_orders = data.map_team_orders;
          this.map_customer_branch = data.map_customer_branch;
          this.events = data.events;
          this.actions = data.actions;
          this.notes = data.notes;
          this.mapOrders = data.map_orders;
          this.calendarViews = data.calendarViews;
          this.config.resources = data.resources;
          this.config.events = data.events;
          this.prevList = data.prevList;
          this.item.team_order = data.teamOrders;

          // Teams für vorgeschlagene Termine aktualisieren
          this.loadAvailableTeams();

          // Scheduler aktualisieren
          this.scheduler.control.update();
          
          // Pagination zurücksetzen
          this.p = 1;
          this.loading = false;

          // Promise erfolgreich auflösen
          resolve();
        },
        err => {
          this.loading = false;
          console.error("Fehler beim Laden der Ressourcen:", err);
          
          // Promise mit Fehler ablehnen
          reject(err);
        }
      );
    });
  }
  


  /*
  onDragStart(event: DragEvent): void {
    // Erstellen Sie das Objekt, das Sie übergeben möchten
    const dragData = {
      obj: this.item,
      duration: this.item.duration * 360,
      id: this.item.id
    };

    // Konvertieren Sie das Objekt in einen String, um es im DataTransfer-Objekt zu setzen
    const dragDataString = JSON.stringify(dragData);
    event.dataTransfer?.setData('application/json', dragDataString);
  }
  */

  getMarker(order): string {
    let orderTypeId = order.order_type_id;
    switch (orderTypeId) {
      case 0: return this.getSvgMarker(order.order_number, 'UMZUG', 'red', 'red','white'); // Pfad oder URL zum Icon
      case 1: return this.getSvgMarker(order.order_number, 'KÜCHE', 'green', 'green','white');
      case 3: return this.getSvgMarker(order.order_number, 'LIEF', '#a335c4', '#a335c4','white');
      // Weitere Fälle für unterschiedliche order_type_ids
      default: return 'default-icon-url';
    }
  }

  getSvgCircularMarker(letters, type, borderColor, circleFillColor, textColor = 'white') {
    // SVG-Code für einen größeren kreisrunden Marker mit zentralem Text und einer Spitze unten
    const svg = `
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="70px" height="70px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
        <g>
            <path d="M256,0C150,0,64,86,64,192c0,123.5,192,320,192,320s192-196.5,192-320C448,86,362,0,256,0z" fill="${borderColor}" stroke-width="15"/>
            <circle cx="256" cy="192" r="140" fill="${circleFillColor}"/>
        </g>
        <text x="50%" y="35%" text-anchor="middle" font-family="'Arial'" font-size="100" font-weight="800" fill="${textColor}">${letters}</text>
        <text x="50%" y="55%" text-anchor="middle" font-family="'Arial'" font-size="80" fill="${textColor}">${type}</text>
    </svg>
    `;
    const encodedSvg = encodeURIComponent(svg);
    return `data:image/svg+xml;utf8,${encodedSvg}`;
}




  getSvgMarker(letters, type, borderColor, rectFillColor, textColor) {
    // SVG-Code für einen Marker mit einem gefüllten Rechteck in der Mitte und zentriertem Text
    const svg = `
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="48px" height="48px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
 <g>
   <path d="M416,0H96C42.969,0,0,42.969,0,96v160c0,53.031,42.969,96,96,96h63.984L256,512l96-160h64c53.031,0,96-42.969,96-96V96
     C512,42.969,469.031,0,416,0z M448,256c0,17.625-14.344,32-32,32H159.984H96c-17.641,0-32-14.375-32-32V96
     c0-17.625,14.359-32,32-32h320c17.656,0,32,14.375,32,32V256z" fill="${borderColor}"/>
 </g>
 <path fill="${rectFillColor}" d="M448,277.74c0,5.666-5.069,10.26-11.322,10.26H75.322C69.069,288,64,283.406,64,277.74V74.26
   C64,68.593,69.069,64,75.322,64h361.355C442.931,64,448,68.593,448,74.26V277.74z"/>
   <text transform="matrix(1 0 0 1 70.6016 150)" font-family="'Arial'" fill="${textColor}" font-size="100" font-weight="600">${type}</text>
 <text transform="matrix(1 0 0 1 70.6016 250)" font-family="'Arial'" fill="${textColor}" font-size="100">${letters}</text>
 </svg>
    `;
    const encodedSvg = encodeURIComponent(svg);
    return `data:image/svg+xml;utf8,${encodedSvg}`;
  }

  navigateToOrder(order: any) {
    this.loading = true;
    this.item = order;

    const newOrderId = order.id;
    const currentUrl = this.router.url;
    const newUrl = currentUrl.replace(/\/order\/\d+/, `/order/${newOrderId}`);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([newUrl]).then(() => {
        this.loading = false;
      });
    });
  }

  dispose(args) {

    console.log('store');
    console.log(args);
    if (args.external) {
      let data = {
        team_order_type_id: this.dispoMode.id,
        start: args.newStart,
        end: args.newEnd,
        resource: args.e.resource(),
        id: args.e.id(),
        data: args.e.data.obj
      }

      // Mit moment.js die Zeitkomponente entfernen und nur das Datum vergleichen
      const getDateWithoutTime = (dateTime) => {
        return moment(dateTime).startOf('day');
      };

      // Suche in this.events nach Items, die den dispo_type: 99 haben,
      // bei denen die Resource 'g' + resource (aber 1 Zeichen weg) ist
      // und bei denen der Start-Zeitpunkt (Datum ohne Zeit) mit dem neuen Startdatum übereinstimmt
      let resource = 'G' + args.e.resource().slice(1); // Nimmt das 'g' und entfernt das erste Zeichen
      let matchingEvents = this.events.filter(event =>
        event.dispo_type === 99 &&
        event.resource === resource &&
        getDateWithoutTime(event.start) == getDateWithoutTime(args.newStart.value) // Vergleich nur des Datums
      );

      //console.log('Match');
      //console.log(matchingEvents);

     

      // Prüfe, ob die Länge von matchingEvents > 0 ist
      if (matchingEvents.length > 0) {
        alert('Es gibt bereits eine Team-Abwesenheit zur gleichen Zeit!');
      }

      this.teamOrderService.store(data).subscribe(
        data => {
          this.toastr.success('Auftrag wurde erfolgreich disponiert');
         
        },
        err => {
          this.toastr.warning(err.error.message, 'Fehler');
        }
      );

    } else {
      console.log(args.newStart + ',' + args.newEnd + ',' + args.e.id());
      let data = {
        start: args.newStart,
        end: args.newEnd,
        resource: args.e.resource(),
        id: args.e.id()
      }
      this.teamOrderService.update(data).subscribe(
        data => {
          this.toastr.success('Auftrag wurde erfolgreich geändert');
        },
        err => {
          this.toastr.warning(err.error.message, 'Fehler');
        }
      );
    };
  }


  onRouterOutletActivate($event) {
    this.fetchResources(null, null);
  }

  switchMiddleSlot(view) {
    this.middleSlot = view;
  }

  getSelectedDate() {
    return this.scheduler.control.visibleStart();
  }

  gotoTeamDetails(id) {
    this.router.navigate(['./team/' + id + '/team-base'], { relativeTo: this.route });
  }

  gotoTeamList() {
    this.router.navigate(['./team/team-list'], { relativeTo: this.route });
  }

  gotoTeamOrder(date: string) {
    if (!this.scheduler || !date) {
      console.error('Scheduler oder Datum nicht definiert.');
      return;
    }
  
    const selectedDate = new DayPilot.Date(date);
  
    // Berechne den Wochenstart (Montag) und das Ende der Woche (Sonntag)
    const startOfWeek = selectedDate.firstDayOfWeek(DayPilot.Locale.find("de-de").weekStarts); // Montag als Start
    const endOfWeek = startOfWeek.addDays(6); // Sonntag
  
    // Setze den Start und die Anzahl der Tage in der Scheduler-Konfiguration
    this.config.startDate = startOfWeek;
    this.config.days = 7; // Zeige die Woche von Montag bis Sonntag
  
    // Lade Ressourcen und Events für den Zeitraum
    this.fetchResources(startOfWeek.toString(), endOfWeek.toString())
      .then(() => {
        // Scrolle zum gewählten Datum
        this.scheduler.control.scrollTo(selectedDate);
  
        // Suche das Event, das dem ausgewählten Datum entspricht
        const event = this.scheduler.control.events.list.find((e: any) => {
          const eventStart = new DayPilot.Date(e.start);
          return eventStart.equals(selectedDate); // Vergleiche die Startzeiten
        });
  
        if (event) {
          // Hervorhebung: Setze Farbe und CSS
          event.data.backColor = "rgba(255, 0, 0, 0.5)";
          event.data.cssClass = "highlighted-event";
  
          // Aktualisiere das Event und scrolle zu seiner Position
          this.scheduler.control.events.update(event);
          this.scheduler.control.scrollTo(event.start); // Scrolle direkt zum Event
          console.log("Event hervorgehoben:", event);
        } else {
          console.warn("Kein Event gefunden für:", selectedDate.toString());
        }
      })
      .catch(error => {
        console.error("Fehler beim Laden der Ressourcen:", error);
      });
  
    // Debug-Ausgabe
    console.log("Start der Woche:", startOfWeek.toString());
    console.log("Ende der Woche:", endOfWeek.toString());
  }
  
    
  

  meBlockEvent(args) {
    this.teamEventService.meBlockEvent(args.source.data.id).subscribe(
      data => {
        this.fetchResources(null,null);
        this.toastr.success('Event wurde blockiert');
      },
      err => {
        this.toastr.error('Event konnte nicht blockiert werden');
      }
    );
  }

  meAddAbsence(args, type) {
    console.log('add absence');
    console.log(args);
    let data = {
      team_base_id: args.source.data.resource.slice(1),
      start_date: args.source.data.start,
      end_date: args.source.data.end,
      absence_type_id: type || 0,
      absence_type: "blocked"

    }
    this.teamAbsenceService.store(data).subscribe(
      data => {
        this.fetchResources(null,null);
        this.toastr.success('Event wurde blockiert');
      },
      err => {
        this.toastr.error('Event konnte nicht blockiert werden');
      }
    );
  }

  meDeleteAbsence(args, type) {
    console.log('delete absence');
    console.log(args);
    let data = {
      id: args.source.data.team_absence[0].id
    }
    
    this.teamAbsenceService.delete(data).subscribe(
      data => {
        this.fetchResources(null,null);
        this.toastr.success('Ausfall wurde aufgehoben');
      },
      err => {
        this.toastr.error('Event konnte nicht blockiert werden');
      }
    );
    
  }

  generateTeamScheduleByDay(date) {
    alert(date);
  }

  zoomOut() {
    this.zoomLevel = 10;
  }

  centerMapOnMarker(orderId: number) {
    console.log(orderId);
    const waypoint = this.map_team_orders.find(wp => wp.order.id === orderId); // Korrektur hier
    console.log(waypoint);
   if (waypoint) {
      this.latitude = waypoint.order.lat;
      this.longitude = waypoint.order.lng;
      //this.zoomLevel = 15;
  
  setTimeout(() => {
    this.map.triggerResize(true);
  }, 500);
}
}



  gotoTeamOrderDetails() {}

    weekView = function() {
      const self = this;
      this.config = {
        
        rowHeaderColumns: [
          {text: "Resource"},
          //{title: "Umsatz", width: 60, display: 'purchase_total'},
          //{text: "Ausl.", width: 60, display: 'marche_total'},
        ],
        rowHeight: 60,
        cellWidthSpec: "Auto",
        durationBarMode: "PercentComplete",
        durationBarHeight: 8,
        //eventSelectHandling: "Enabled",
        timeHeaders: [
            {
                "groupBy": "Month"
            },
            {
                "groupBy": "Week",
                "format": "KW"
            },
            {
                "groupBy": "Day",
                "format": "ddd,dd.MM"
            },
        ],
        scale: "Day",
        //allowMultiSelect: false,
        //eventClickHandling: "Select",
        cellDuration: 1,
       
        locale: "de-de",
        dynamicLoading: false,
        eventHeight: 100,
        multiSelect: false,
        eventClickHandling: "Enabled",
        eventMoveHandling: "Update",
        allowEventOverlap: true,

        showNonBusiness: true,  // Setzt fest, dass keine Non-Business Tage angezeigt werden
        businessBeginsHour: 7,
        businessEndsHour: 22,
        businessDays: [1, 2, 3, 4, 5, 6], // Montag (1) bis Samstag (6)
        days: 6,  // Anzahl der angezeigten Tage auf 6 setzen

       
        startDate: DayPilot.Date.today().firstDayOfWeek(1),
        treeEnabled: true,
        rowMoveHandling: "Update",
        //treePreventParentUsage: true,
        heightSpec: "Parent100Pct",
        onRowMoved: args => {
          //this.ds.moveResource(args.source, args.target, args.position).subscribe(result => this.scheduler.control.message("Moved"));
        },
        /*
        onRowSelected: (args) => {
          alert('showMap');
          //this.showMap(args);
        },
        */

        //contextMenu: this.eventMenu, // Kontextmenü für Ereignisse zuweisen
        //masterEventMenu: this.masterEventMenu,
        // Event Handling für das Kontextmenü
        onEventRightClick: function(args) {
            //this.eventMenu.show(args.e);
            //args.stopPropagation();
            args.preventDefault(); // Verhindert das Standard-Rechtsklick-Menü
            this.masterEventMenu.show(args.e);
        },

        onTimeRangeRightClick(args: any) {
          console.log('onTimeRangeRightClick');
          console.log(args);
          self.selectedResource = args.resource;
          self.selectedDate = args.start;
          
          // Verhindere das Standard-Rechtsklick-Menü
          args.preventDefault();
          
          // Erstelle das Menü dynamisch
          const menu = new DayPilot.Menu({
            zIndex: 1200,
            items: [
              {
                icon: "fa fa-clipboard",
                text: "Termin einfügen",
                onClick: async () => {
                  self.pasteTeamOrder();
                }
              }
            ]
          });
          
          // Zeige das Menü
          menu.show(args.e);
        },

        onBeforeContextMenuRender: function(args) {
          args.menu.zIndex = 10000; // Setze den z-index des Menüs
        },

        emptyEventMenu: new DayPilot.Menu({
          zIndex: 1200,
          items: [
            {
              icon: "fa fa-clipboard",
              text: `Termin einfügen`,
              onClick: async args => {
                
                // Da das selektierte Datum und die Ressource nicht in args enthalten sind,
                // müssen wir annehmen, dass sie auf andere Weise abgerufen werden.
                // Hier wird ein Platzhalter für die Logik eingefügt, um das Datum und die Ressource zu erhalten.
               
                self.pasteTeamOrder();
              }
            }
          ]
        }),
  
        masterEventMenu: new DayPilot.Menu({
          zIndex: 1200,
          items: [
              {
              icon: "fa fa-info-circle",
              text: this.teamOrderService.getClipboardObject() || "Keine Auftragsnummer",
              onClick: async args => {
                // Platzhalter für Auftragsnummer, nicht klickbar
                this.copyPasteTeamOrder(args);
              }
              
            },
            
            {
              icon: "fa fa-edit",
              text: "Auftrag bearbeiten",
              onClick: async args => {
                this.editOrder(args);  // Sicherstellen, dass "this" auf die richtige Instanz verweist
              }
            },
            {
              icon: "fa fa-calendar",
              text: "Termin bearbeiten",
              onClick: async args => {
                this.editTeamOrder(args);  // Sicherstellen, dass "this" auf die richtige Instanz verweist
              }
            },

           
            {
              icon: "fa fa-arrows-alt",
              text: "Termin verschieben",
              onClick: async args => {
                this.copyPasteTeamOrder(args.source.data);

              }
            },
            /*
            {
              icon: "fa fa-circle text-yellow-500", // Gelber Kreis vor dem Text
              text: "Termin reservieren / nicht reservieren",
              onClick: async args => {
                this.reserveTeamOrder(args.source.data);
              }
            
            },
            */
            {
              icon: "fa fa-flag",
              text: "Status ändern",
              onClick: async args => {
                this.openStatusChangeModalFromContextMenu(args.source.data);
              }
            },
            
            {
              icon: "fa fa-circle text-green-500",
              text: "Terminbestätigung /(aufheben)",
              onClick: async args => {
                this.confirmAppointment(args.source.data);
              }
            
            },

             {
              icon: "fa fa-circle text-red-500",
              text: "AUSFALL",
              onClick: async args => {
                this.setIsNoShow(args.source.data);
                this.scheduler.control.events.update(args.source.data); // Event aktualisieren
                this.scheduler.control.update(); // UI neu rendern
              }
            },
            /*
            {
              icon: "fa fa-circle text-red-700",
              text: "stornieren",
              onClick: async args => {
                this.setIsNoShow(args.source.data);
                this.scheduler.control.events.update(args.source.data); // Event aktualisieren
                this.scheduler.control.update(); // UI neu rendern
              }
                
            },
            */
             
            {
              icon: "fa fa-trash",
              text: "Termin aufheben",
              onClick: async args => {
                this.deleteTeamOrder(args.source.data);
                
              }
            },
           
          ]
        }),
        

        

        onEventClicked: async args => {
          if (args.e.data.dispo_type == 100) {
            alert('Feiertag');
          } {
  
          // Vorheriges Highlight entfernen (falls vorhanden)
          if (this.selectedEventId) {
            const previousEvent = this.scheduler.control.events.find(e => e.id() === this.selectedEventId);
          
            if (previousEvent) {
              console.log(previousEvent);
              previousEvent.data.cssClass = previousEvent.data.originalCssClass || ""; // Ursprüngliche CSS-Klasse wiederherstellen
            }
          }
        
          // Neues Event speichern und highlighten
          this.selectedEventId = args.e.id();
          
          // Originale CSS-Klasse speichern (falls es eine gab)
          if (!args.e.data.originalCssClass) {
            args.e.data.originalCssClass = args.e.data.cssClass || "";
          }
        
          // Neue Highlight-Klasse setzen
          args.e.data.cssClass = "event-highlight";
          args.e.data.backColor = "#fff";
          // Scheduler aktualisieren
          
            // **Events aktualisieren**
          this.scheduler.control.events.update(args.e.data); 
          this.scheduler.control.update(); // UI neu rendern
          
          // Falls das nicht ausreicht:
          this.scheduler.control.events.list = [...this.scheduler.control.events.list]; 
          this.scheduler.control.update(); 
          
          //this.scheduler.control.message("Event aktualisiert!"); // Debug-Ausgabe

          

          console.log("Geklicktes Event:", args.e);
        
          // Weitere Logik für Kalender-Modus
          if (this.calmod == 'calendar') {
            this.selectedSecMenuIndex = 0;
            this.selectedEvent = args.e.data;
            this.fetchOrderDetails(args.e.data.order_id);
          } else if (this.calmod == 'scheduler') {
            this.selectedSecMenuIndex = 0;
            this.fetchOrderDetails(args.e.data.order_id);
          }
        }
        },
        

        onEventMoving: (args) => {
          console.log('onEventMoving');
          args.allow = true;
        },

        onEventMoved: (args) => {
          console.log('onEventMoved');
         
        
          args.allow = true;
          //args.preventDefault();
          if (args.newResource.startsWith('O')) {
            //args.preventDefault();
            this.dispose(args);
            this.fetchResources(null,null);
            this.onPostDropActions(args);
            //this.scheduler.update();
          } else {
            //args.preventDefault();
            this.dispose(args);
            this.onPostDropActions(args);
            //this.disposeEvent(args); //store event in db
          }       
        },

        onEventResize: (args) => {
          var event = args.e;
          //args.preventDefault();
          this.disposeEvent(args); 
          
          //this.fetchResources();
        },

        onResourceHeaderClick: function(args) {
          if (args.resource.level === 2) {
            console.log(args);
            self.gotoTeamDetails(args.e.rid());
          };
        },
      
        onBeforeTimeHeaderRender: function (args) {

          if (args.header.level === 2) {
              //console.log(args.header.start);
              args.header.areas = [
                  {
                      right: 5,
                      top: 5,
                      height: 20,
                      width: 20,
                      useBody: true,
                      action: "ContextMenu",
                      icon: "icon icon-menu",
                      cssClassPrefix: "custom_menu", 
                      menu: new DayPilot.Menu({
                          zIndex: 1200,
                          items: [
                              { text: "Einsatzplan als PDF erstellen",
                                  onClick: function(args) {
                                      self.generateTeamScheduleByDay(args.source.start.value);
                                  }
                              },
                              { text: "Tagesansicht",
                                  onClick: function(args) {
                                      self.generateTeamScheduleByDay(args.source.start.value);
                                  }
                              },
                              { text: "Tour prüfen",
                                  onClick: function(args) {
                                      alert('Print PDF');
                                  }
                              }
                          ]
                      }),
                      style: "background-color: #ddd; text-align: left;font-size: 10px; font-weight: regular;",
                  }
              ];
              //args.header.html = "Week " + args.header.start.weekNumberISO();
          };
          
        },
        
    
        //contextMenuResource: this.menu,
        
        onBeforeRowHeaderRender: args => {
          const row = args.row;
          const resourceId = row.id;
          const resources = self.config?.resources || [];
          const findRes = (list: any[], id: string): any => {
            if (!list) return null;
            for (const r of list) {
              if (r.id === id) return r;
              if (r.children) { const found = findRes(r.children, id); if (found) return found; }
            }
            return null;
          };
          const resource = findRes(resources, resourceId);
          const skillItems = resource?.skill_items || [];
          const name = resource?.name || row.name || row.text || resourceId || '';
          if (skillItems.length > 0 && row.columns && row.columns[0]) {
            const byCategory: { [key: string]: any[] } = {};
            skillItems.forEach((s: any) => {
              const cat = s.skill_category?.title || s.skill_category?.name || 'Sonstige';
              if (!byCategory[cat]) byCategory[cat] = [];
              byCategory[cat].push(s);
            });
            const popupBlocks = Object.keys(byCategory).map(cat => {
              const badges = byCategory[cat].map((s: any) => {
                const color = (s.color || '#6c757d').replace(/^#/, '');
                const title = (s.title || s.name || '').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                return `<span class="scheduler-row-skill-badge" style="display:inline-block;font-size:10px;padding:2px 6px;border-radius:3px;margin:2px 3px 2px 0;background-color:#${color};color:#fff;">${title}</span>`;
              }).join('');
              const catEsc = cat.replace(/</g, '&lt;').replace(/"/g, '&quot;');
              return `<div class="scheduler-row-skills-category"><span class="scheduler-row-skills-category-name">${catEsc}</span><div class="scheduler-row-skills-category-badges">${badges}</div></div>`;
            }).join('');
            const skillTitles = skillItems.map((s: any) => (s.title || s.name || '').replace(/"/g, '&quot;')).join(', ');
            row.columns[0].html = `<div class="scheduler-row-header-content"><span class="scheduler-row-name">${(name || '').replace(/</g, '&lt;')}</span><span class="scheduler-row-skills-icon-wrapper" title="${skillTitles}"><i class="fa fa-tags scheduler-row-skills-icon"></i><div class="scheduler-row-skills-popup">${popupBlocks}</div></span></div>`;
          } else if (row.columns && row.columns[0] && name) {
            row.columns[0].html = `<span class="scheduler-row-name">${(name || '').replace(/</g, '&lt;')}</span>`;
          }
          row.areas = [
            {
              right: 2,
              top: 2,
              width: 14,
              height: 14,
              useBody: true,
              action: "ContextMenu",
              icon: "icon icon-menu",
              cssClassPrefix: "custom_menu", 
              //symbol: "assets/daypilot.svg#minichevron-down-2",
              style: "font-size: 12px; border: 1px solid #ccc; padding: 2px; cursor:pointer; background-color: #ddd",
              //visibility: "Hover",
              menu: new DayPilot.Menu({
                zIndex: 1200,
                items: [
                    { text: "editieren",
                      onClick: async args => {
                        //console.log('teamBase:' + JSON.stringify(args));
                        self.gotoTeamDetails(args.source.data.dbid)
                      }
                    },
                    { text: "Tagesansicht",
                        onClick: function(args) {
                            self.generateTeamScheduleByDay(args.source.start.value);
                        }
                    },
                    { text: "Tour prüfen",
                        onClick: function(args) {
                            alert('Print PDF');
                        }
                    }
                ]
            }),
            }
          ];
        },
        

        
        rowClickHandling: 'Select',
        onEventDrop(args) {
          // Verhindere, dass ein neues Event in der GUI erstellt wird
          args.preventDefault();
      
          // Hier kannst du den Event speichern und andere gewünschte Aktionen ausführen
        },

        onBeforeCellRender: function(args) {
          // Überprüfen, ob das aktuelle Datum und die Ressource den Kriterien 
          
          if (this.highlightedDates && this.highlightedDates.some(d => d.isEqual(args.cell.start))) {
            args.cell.backColor = "rgba(255,0,0,0.3)";
            args.cell.cssClass = "highlighted-cell";
          }
          

          if (args.cell.start.toString("yyyy-MM-dd") === "2024-03-15" && args.cell.resource === "parent") {
              // Prüfen, ob in den Kind-Ressourcen ein Event an diesem Tag vorhanden ist
              var hasEventInChild = this.events.some(function(e) {
                  return e.start.toString("yyyy-MM-dd") === "2024-03-15" && (e.resource === "child1" || e.resource === "child2");
              });
              
              if (hasEventInChild) {
                  // Text für die Eltern-Ressource positionieren
                  args.cell.html = "Test"; // Fügen Sie Ihren Text hinzu
                  // Anpassen der Zellen, z.B. Hintergrundfarbe ändern
                  args.cell.backColor = "#f0f0f0";
              }
          }
          
          // Füge das Kontextmenü zur Zelle hinzu
          args.cell.contextMenu = self.emptyEventMenu;
      },

      
      onBeforeEventRender: function (args) {
        const self = this;
        switch (args.data.dispo_type) {
          case 100:
          case 99:
            //let employeeEventsColor = args.data.data[0].amount_employees == 0 ? "red" : "black";
            //let vehicleEventsColor = args.data.data[1].amount_vehicles == 0 ? "red" : "black";
            args.data.height = 30;
            args.data.contextMenu = this.masterEventMenu; // Verknüpfen des Menüs
            args.data.moveDisabled = false;
            args.data.movable = false;

      
            // Setting tooltip content
            //let tooltipContent = `Mitarbeiter: ${args.data.data[0].amount_employees}<br>Fahrzeuge: ${args.data.data[1].amount_vehicles}<br>Arbeitslast: ${args.data.workload}%`;
      
            //args.data.html = `<div style='font-weight: bolder; font-size: 14px; padding-right: 5px; height: 100%; border-right: 1px solid #555' title='${tooltipContent}'>
            //                    <span class="text-xs font-extrabold">${args.data.workload}%<br></span>
            //                    <span style='color: ${employeeEventsColor};'>${args.data.data[0].amount_employees}</span><br>
            //                    <span style='color: ${vehicleEventsColor};'>${args.data.data[1].amount_vehicles}</span>
            //                  </div>`;
            //args.data.html += `<div style='border: 0px; padding-left: 4px; padding-top: 12px; line-height: 10px;' title='${tooltipContent}'>`;
            //if (args.data.amount_orders > 0) {
            //  args.data.backColor = "#eee";
            //} else {
            //  args.data.backColor = "#fff";
            //}
            //args.data.html += `<span style='font-size: 10px; line-height: 5px !important; margin-top: -1px !important'><strong></strong>${args.data.default_start}-${args.data.default_end} (${args.data.working_hours})</span><br>`;
            //args.data.html += `<span style='font-size: 10px; margin-top: 20px; line-height: 10px;'><strong>${args.data.data[0].employees}</strong></span><br>`;
            //args.data.html += `<span style='font-size: 10px; line-height: 5px !important; margin-top: -1px !important'><strong></strong>${args.data.data[1].vehicles}</span></div>`;
      
            args.data.complete = args.data.workload;
            args.data.barBackColor = "#aaa";
            if (args.data.workload > 75) {
              args.data.barColor = "red";
            } else {
              if (args.data.workload > 50) {
                args.data.barColor = "orange";
              } else {
                args.data.barColor = "green";
              }
            }
            args.data.barHidden = false;

            if(args.data.team_absence?.length > 0) {
              
              args.data.backColor = "#ff0000";
              args.data.html = "<small class='text-white'>" + args.data.team_absence[0].absence_type?.name + "</small>";
            } else {
              args.data.html = "<small>" + args.data.amount_orders + " | " + args.data.amount_me + "€ </small>";
              if(args.data.holiday_name)  {
                args.data.html += "<small class='font-bold'> [" + args.data.holiday_name + "]</small>"
                args.data.backColor = "#f57242";}
              
              
            }
            if (args.data.blocked || args.data.team_absence?.length > 0) {
              /*
              args.data.html += `<div style='position: absolute; top: 14; left: 0; width: 100%; height: 100%; background: none;'>
                                  <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0" y1="0" x2="100%" y2="100%" stroke="black" stroke-width="2"/>
                                    <line x1="100%" y1="0" x2="0" y2="100%" stroke="black" stroke-width="2"/>
                                  </svg>
                                </div>`;*/
            }



            /*
            if (args.data.verified === false) {

              args.data.html += `<div style='position: absolute; bottom: 0; right: 0;'>
                                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="24" fill="red"/>
                                    <text x="12" y="18" text-anchor="middle" fill="white" font-size="12" font-family="Arial" dy=".3em">nQ!</text>
                                  </svg>
                                </div>`;
            } else {
              args.data.html += `<div style='position: absolute; bottom: 0; right: 0;'>
                                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="24" fill="green"/>
                                    <text x="12" y="18" text-anchor="middle" fill="white" font-size="12" font-family="Arial" dy=".3em">OK</text>
                                  </svg>
                                </div>`;
            }
            */
      
            args.data.areas = []; // No areas for the default case
      
            // Conditionally set a red border if either amount is 0
            /*
            if (args.data.amount_vehicle_events == 0 || args.data.amount_employee_events == 0) {
              args.data.borderColor = "red";
              args.data.borderWidth = 5; // Sets the border thickness
            }
            */
      
            /*
            args.data.areas.push({
              top: 7,
              right: 4,
              width: "100%",
              height: 14,
              html: "<div style='font-size: 8px; height: 100%; width: 100%; text-align: center;'><span class='text-black; text-xs'>" + args.data.amount_orders + " |</span><span class='ml-0.5 text-xs font-bold'>" + args.data.amount_me + "€</span><span class='ml-0.5 text-xs'> | 100km</span></div>", // HTML-Inhalt
              action: "None" // Keine Aktion beim Klicken
            });
            */
      
            args.data.areas.push({
              top: 5,
              right: 3,
              height: 12,
              icon: "fa fa-chevron-down",
              visibility: "Hover",
              action: "ContextMenu",
              //menu: this.masterEventMenu,  // Verknüpfen des Menüs
              style: "font-size: 12px; background-color: rgba(255, 255, 255, .5); border: 1px solid #aaa; padding: 3px; cursor:pointer;",
              menu:  new DayPilot.Menu({
                zIndex: 1200,
                items: [
                  {
                    text: "Rollkarte anzeigen",
                    onClick: async args => {
                      //this.deleteEvent(args);
                    }
                  },
                  {
                    text: "Ausfall", 
                    items: [ 
                      {
                        text: "blockiert",
                        onClick: async args => {
                          this.meAddAbsence(args,0);
                        }
                      },
                      {
                        text: "Krankmeldung",
                        onClick: async args => {
                          this.meAddAbsence(args,1);
                        }
                      },
                      {
                        text: "Urlaub",
                        onClick: async args => {
                          this.meAddAbsence(args,2);
                        }
                      },
                      {
                        text: "Weiterbildung",
                        onClick: async args => {
                          this.meAddAbsence(args,3);
                        }
                      },
                    ]
                  },
                  {
                    text: "Ausfall aufheben",
                    onClick: async args => {
                      this.meDeleteAbsence(args);
                    }
                  },
                  {
                    text: "Notizen setzen (TODO)",
                    onClick: async args => {
                      //this.meSetDefault(args);
                    }
                  },
                  {
                    text: "Aktionen", 
                    items: [ 
                      {
                        text: "Aktion 1",
                        onClick: async args => {
                          //this.meFill(args);
                        }
                      },
                      {
                        text: "Aktion 2",
                        onClick: async args => {
                          //this.meFill(args);
                        }
                      },
                      {
                        text: "Aktion 3",
                        onClick: async args => {
                          //this.meFill(args);
                        }
                      }
                    ]
                  },
                 
                  // Fügen Sie hier weitere Menüpunkte hinzu
                ]
              })
            });
      
            break;
          default:
            args.data.barHidden = true;
            args.data.contextMenu = this.masterEventMenu;
            var dateStart = new Date(args.data.start);
            var dateEnd = new Date(args.data.end);
            args.data.cssClass = args.data.cssClass;
            args.data.backColor = this.getBackgroundColor(args.data.order);
            args.data.textColor = '#000';
            args.data.movable = true;
            args.data.disabled = false;
          
           
            var timeStringStart = dateStart.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            var timeStringEnd = dateEnd.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            
            //Time
            //args.data.html = "<div style='padding-left: 10px;'><small><strong>" + timeStringStart + "</strong> - <strong>" + timeStringEnd + " </strong><strong>" + args.data.last_name + "</strong>(" + args.data.order_number + ")<br>";

            const selectedReklaTypeLabel = this.getReklaSelectedTypeLabel(args.data.order);
            const selectedReklaMinutes = this.getReklaSelectedMinutes(args.data.order);
            const selectedReklaDisplay = selectedReklaMinutes != null ? this.helper.convertMinutesToHours(selectedReklaMinutes) : '-';
 
            const orderStatusId = args.data.order?.status_id ?? args.data.order?.status?.id ?? null;
            const orderStatusLabel = args.data.order?.status?.label || args.data.order?.status?.name || '';
            const orderStatusColor = args.data.order?.status?.color || '#6c757d';
            const statusDisplayText = orderStatusLabel || (orderStatusId != null ? 'Status ' + orderStatusId : '');
            args.data.html = "<div style='padding-left: 5px;'><strong>" + args.data.order?.order_number + "</strong> " + args.data.order?.root_order?.person?.last_name;

             
            // Status oben, volle Breite: status.label + status.color (wie order-disposition)
            if (statusDisplayText) {
              args.data.html += `<div style="position: absolute; top: 0; left: 0; width: 100%; background-color: ${orderStatusColor}; color: #fff; text-align: center; padding: 2px 0; font-size: 0.8rem; font-weight: bold; z-index: 1000;">${statusDisplayText}</div>`;
            } else if (args.data.is_no_show) {
              args.data.html += `<div style="position: absolute; top: 0; left: 0; width: 100%; background-color: #ff0000; color: #fff; text-align: center; padding: 2px 0; font-size: 0.8rem; font-weight: bold; z-index: 1000;">AUSFALL</div>`;
            } else if (args.data.is_canceled) {
              args.data.html += `<div style="position: absolute; top: 0; left: 0; width: 100%; background-color: #ff0000; color: #fff; text-align: center; padding: 2px 0; font-size: 0.8rem; font-weight: bold; z-index: 1000;">STORNO</div>`;
            }

          args.data.html += `<div style="position: absolute; top: 0; right: 0; z-index: 1000;">`;
          args.data.html += `<div style="background-color: #6c757d; color: #fff; padding: 2px 5px; font-size: 0.75rem; border-radius: 3px;">${args?.data.team_order_type?.short || 'no Type'}</div>`;
          args.data.html += `</div>`;
           
          if (args.data.order?.order_type_id == 0) {
              args.data.html += `
              <div style="position: absolute; top: 18px; right: 0; z-index: 1000;">
                  <div style="background-color: #6c757d; color: #fff; padding: 2px 5px; font-size: 0.75rem; border-radius: 3px;">
                      ${this.getPayerShort(args.data.order) || 'no Type'}
                  </div>
                   
              </div>`;
          }
            
          
    
            
            args.data.html += "<br>";
            args.data.html += "<span class='text-xs'>" + args.data.order?.root_order?.person?.postal_code + " " + args.data.order?.root_order?.person?.place + "</span><span class='text-xs'><br>";

            if (args.data.order?.order_type_id == 0) {
              //Rekla
       
              /*
              args.data.html += `
              ${this.getPayerName(args.data.order) ? '' : '<span class="text-red-600 warning-icon">&#9888;</span>'}
                <strong class='text-xs'>${this.getPayerName(args.data.order) || '-'}</strong><br>
              `;
              */

              const durationWarning = selectedReklaMinutes == null ? '<span class="text-red-600 warning-icon">&#9888;</span>' : '';
              args.data.html += `
                ${durationWarning}
                <span class="material-icons" style="font-size: 1.4em; vertical-align: -0.2em;">access_time</span>
                ${selectedReklaTypeLabel ? selectedReklaTypeLabel + ': ' : ''}
                ${selectedReklaDisplay}, 
                ${(args.data.order?.rev_total == null) ? '<span class="text-red-600 warning-icon">&#9888;</span>' : ''}
                U: <strong>${(args.data.order?.rev_total ?? args.data.order?.order_calcs_total) || '-'}</strong> EUR
              `;

              //args.data.html += "<br><span><strong class='text-xs'>" + args?.data.team_order_type?.name || 'no Type' + "</strong></span></div>";
            } else {
              //Küche
      
              
              args.data.html += `
                ${args.data.order?.order_value == null ? '<span class="text-red-600 warning-icon">&#9888;</span>' : ''}
                <strong>WW:</strong> ${args.data.order?.order_value || '-'} EUR<br>
              `;
              
              args.data.html += `
              ${args.data.order?.amount_total == null ? '<span class="text-red-600 warning-icon" alt="Keine Montageeinheiten(ME) hinterlegt">&#9888;</span>' : ''}
              <strong>ME: </strong>${args.data.order?.amount_total || '-'}ME, ${args.data.order?.rev_total ?  args.data.order?.rev_total + ' EUR' : '-'}, (${this.helper.convertMinutesToHours(args.data.order?.duration) || '-'})</span>
`;
              //args.data.html += "<br><span><strong class='text-xs'>" + args?.data.team_order_type?.name || 'no Type' + "</strong></span></div>";  
            }

            if (args.data.comment) {
              args.data.html += "<div class='inline-block bg-gray-800 text-white text-xs' style='padding: 2px 5px; border-radius: 3px; position: absolute; bottom: 0; left: 0; width: 100%;'>" + args?.data.comment + "</div>"
            }  
            if (args.data.blocked) {
              args.data.html += `<div style='position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255, 0, 0, 0.5) 10px, rgba(255, 0, 0, 0.5) 20px);'></div>`;
            }

            if (args.data.is_canceled) {
              args.data.html += `
                <div style='
                  position: absolute; 
                  top: 0; 
                  left: 0; 
                  width: 100%; 
                  height: 100%;
                  pointer-events: none;
                '>
                  <!-- Exakte diagonale Linie von unten links nach oben rechts -->
                  <div style='
                    position: absolute; 
                    bottom: 0;
                    left: 0;
                    width: 140%; /* Dynamisch für exakte Länge */
                    height: 2px;
                    background-color: red; 
                    transform: rotate(-45deg);
                    transform-origin: bottom left;
                  '></div>
            
                  <!-- Rotes Label "STORNO" exakt oben rechts in der Ecke -->
                  <div style='
                    position: absolute; 
                    top: 0;
                    right: 0;
                    background-color: red; 
                    color: white; 
                    font-size: 10px; 
                    font-weight: bold;
                    padding: 2px 6px;
                    border-bottom-left-radius: 3px;
                  '>
                    STORNO
                  </div>
                </div>
              `;
            }
            
            
            
            
            
            


            
            args.data.areas = [
              { top: 5, right: 3, height: 12, icon: "fa fa-chevron-down", visibility: "Hover", action: "ContextMenu", style: "font-size: 12px; background-color: rgba(255, 255, 255, .5); border: 1px solid #aaa; padding: 3px; cursor:pointer;" }
            ];

           
            args.data.areas = [
              {
                action: 'Bubble',
                onMouseEnter: (args) => { // Verwendung einer Pfeilfunktion
                  
                  //TODO
                  //self.centerMapOnMarker(args.source.data.order?.id);
                  //const eventElement = args.e.container; // DayPilot-Element
                  /*
                  if (eventElement) {
                      eventElement.classList.add('event-highlight');
                  }
                      */
                },
                onMouseLeave: (args) => { // Verwendung einer Pfeilfunktion
                 
                  //self.zoomOut();
                 /*
                  const eventElement = args.e.container;
                  if (eventElement) {
                      eventElement.classList.remove('event-highlight');
                  }
                      */
                },
                /*
                bubble: new DayPilot.Bubble({
                  onLoad: (args) => {
                      const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };
                      const start = new Date(args.source.data?.start).toLocaleTimeString('de-DE', options); 
                      const end = new Date(args.source.data?.end).toLocaleTimeString('de-DE', options); 
              
                      // Skills durchloopen und als Badges ausgeben
                      let skillsHtml = '';
                      if (Array.isArray(args.source.data?.skills)) {
                          skillsHtml = args.source.data.skills
                              .map(skill => `<span class="badge badge-success" [ngStyle]="{'background-color': ${skill.color}, 'color': '#000'}">
                                  ${ skill.title }</span><br>`)
                              .join(' ');
                      }
              
                      args.html = '<i>' + args.source.data.order?.order_type?.label + '</i><br>' +
                          args.source.data.order?.first_name + ' <strong>' +
                          args.source.data.order?.last_name + '</strong><br>' +
                          args.source.data.order?.street + ', ' +
                          args.source.data.order?.postal_code + ' ' +
                          args.source.data.order?.place + '<br>' +
                          args.source.data.order?.amount_total + 'ME | ' +
                          (args.source.data.order?.order_calcs_total || 0) + '€<br>' +
                          start + 'Uhr - ' + end + 'Uhr<br>' +
                          (skillsHtml ? `${skillsHtml}<br>` : ''); // Falls keine Skills vorhanden sind, wird dieser Teil nicht angezeigt
                  },
                  
                  animated: true,
                  showLoadingLabel: false,
                  showAfter: 100,
                  hideAfter: 100,
                  zIndex: 1200
                  
              }),*/
              
              
                left: 0, right: 0, top: 0, bottom: 0, 
                //style: "background-image: linear-gradient(135deg, #B5ADE6 10%, transparent 10%, transparent 50%, #B5ADE6 50%, #B5ADE6 60%, transparent 60%, transparent); background-size: 10px 10px;"
              }
            ];

            

            
            /*
            args.data.areas.push({
              top: 5,
              right: 3,
              height: 12,
              icon: "fa fa-chevron-down",
              visibility: "Hover",
              menu: this.masterEventMenu,  // Verknüpfen des Menüs
              style: "font-size: 12px; background-color: rgba(255, 255, 255, .5); border: 1px solid #aaa; padding: 3px; cursor:pointer;"
            });
            */
            
      
            break;
        }
        
    
      
      }.bind(this)
      
      
      };

      





    

    
  
    }

  // Properties für vorgeschlagene Termine
  suggestedAppointments: any[] = [];
  selectedSuggestedTeam: string = '';
  availableTeams: any[] = [];

  // Lade verfügbare Teams für Vorschläge (nur die im Kalender angezeigten)
  loadAvailableTeams() {
    // Verwende die Teams aus dem aktuellen Kalender-Kontext
    if (this.resource && this.resource.length > 0) {
      this.availableTeams = this.resource.map((r: any) => ({
        id: r.id,
        label: r.name || r.text || r.label // NICHT trimmen für Select-Field
      }));
      this.loadSuggestedAppointments(); // Initiale Vorschläge laden
    } else {
      // Fallback: Alle Teams laden wenn keine Kalender-Ressourcen verfügbar
      this.teamBaseService.getAll().subscribe({
        next: (teams) => {
          this.availableTeams = teams; // NICHT trimmen für Select-Field
          this.loadSuggestedAppointments();
        },
        error: (error) => {
          console.error('Fehler beim Laden der Teams:', error);
          this.availableTeams = [];
        }
      });
    }
  }

  // Lade vorgeschlagene Termine basierend auf Team-Auswahl
  loadSuggestedAppointments() {
    const params = {
      team_id: this.selectedSuggestedTeam || null,
      limit: 9 // 3x3 Grid
    };

    this.orderService.getSuggestedAppointments(params).subscribe({
      next: (suggestions) => {
        this.suggestedAppointments = suggestions;
      },
      error: (error) => {
        console.error('Fehler beim Laden der Terminvorschläge:', error);
        // Fallback zu Fake-Daten
        this.generateFakeSuggestions();
      }
    });
  }

  // Fallback: Generiere Fake-Vorschläge
  generateFakeSuggestions() {
    this.suggestedAppointments = [];
    const teams = this.availableTeams.length > 0 ? this.availableTeams : [
      { id: 1, label: 'Team Alpha' },
      { id: 2, label: 'Team Beta' },
      { id: 3, label: 'Team Gamma' },
      { id: 4, label: 'Team Delta' }
    ];

    for (let i = 0; i < 9; i++) {
      const date = new Date();
      date.setDate(date.getDate() + i);
      
      const times = ['09:00', '11:30', '14:00', '16:30'];
      const team = teams[i % teams.length];
      
      // Teamname kürzen für bessere Darstellung
      const trimmedTeamName = this.trimTeamNameForSuggestions(team.label);
      
      this.suggestedAppointments.push({
        id: i + 1,
        date: date,
        time: times[i % times.length],
        teamName: trimmedTeamName,
        teamId: team.id,
        fullDate: `${date.toLocaleDateString('de-DE')} ${times[i % times.length]}`
      });
    }
  }


  // Kürzt Teamnamen für Vorschläge
  trimTeamNameForSuggestions(name: string): string {
    if (!name) return '';
    
    // Entferne überflüssige Leerzeichen
    let trimmed = name.trim();
    
    // Kürze auf maximal 17 Zeichen für Vorschläge (5 Zeichen mehr)
    if (trimmed.length > 17) {
      trimmed = trimmed.substring(0, 14) + '...';
    }
    
    return trimmed;
  }

  // Wähle einen vorgeschlagenen Termin aus
  selectSuggestedAppointment(suggestion: any) {
    console.log('Vorgeschlagener Termin ausgewählt:', suggestion);
    // Hier kannst du die Logik für die Terminauswahl implementieren
    // z.B. Termin im Kalender erstellen, Team zuweisen, etc.
  }

  // Team für Vorschläge auswählen
  selectSuggestedTeam(teamId: string) {
    this.selectedSuggestedTeam = teamId;
    this.loadSuggestedAppointments();
  }

  // Name des ausgewählten Teams anzeigen
  getSelectedTeamName(): string {
    if (!this.selectedSuggestedTeam) {
      return 'Alle Teams';
    }
    const team = this.availableTeams.find(t => t.id == this.selectedSuggestedTeam);
    return team ? team.label : 'Alle Teams';
  }

  // Legacy-Methoden für Kompatibilität (falls noch verwendet)
  getSuggestedDate(index: number): Date {
    const base = new Date();
    const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    d.setDate(d.getDate() + index);
    const pattern = [9 * 60, 11 * 60 + 30, 14 * 60, 16 * 60 + 30];
    const minutes = pattern[index % pattern.length];
    d.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);
    return d;
  }

  getSuggestedTime(index: number): string {
    const d = this.getSuggestedDate(index);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  getSuggestedTeamLabel(index: number): string {
    const teams = ['Team Alpha', 'Team Beta', 'Team Gamma', 'Team Delta'];
    return teams[index % teams.length];
  }

  // Methode zum Styling der Header-Zellen
  styleHeaderCells() {
    setTimeout(() => {
      const headerCells = document.querySelectorAll('.bg-gray-600');
      headerCells.forEach((cell: Element) => {
        const htmlCell = cell as HTMLElement;
        htmlCell.style.setProperty('background', '#2c3e50', 'important');
        htmlCell.style.setProperty('background-color', '#2c3e50', 'important');
        htmlCell.style.setProperty('color', '#ffffff', 'important');
        htmlCell.style.setProperty('font-weight', 'bold', 'important');
        htmlCell.style.setProperty('text-align', 'center', 'important');
        htmlCell.style.setProperty('padding', '12px', 'important');
        htmlCell.style.setProperty('border', '1px solid #34495e', 'important');
      });
    }, 100);
  }


}
